/** Decimals a number field rounds to unless its config says otherwise; every px dimension field keeps it */
export const NUMBER_FIELD_DECIMALS = 0;
